// helpers/flag.ts
import { A } from "@adornis/base/env-info.js";
import isoCountries from "@hotosm/iso-countries-languages";
globalThis.getCountries = isoCountries.getCountries;
globalThis.getCountry = isoCountries.getCountry;
globalThis.getLanguages = isoCountries.getLanguages;
globalThis.getLanguage = isoCountries.getLanguage;
globalThis.getSupportedLangs = isoCountries.getSupportedLangs;
var flagAlias = {
  en: "gb",
  ja: "jp",
  cs: "cz",
  el: "gr",
  fa: "ir",
  he: "il",
  ko: "kr",
  uk: "ua",
  zh: "cn",
  ku: "iq"
};
function getFlagByLangAbbreviation(lang) {
  lang = lang.toLocaleLowerCase();
  const flag = flagAlias[lang] ?? lang;
  return A.absoluteUrl(`/api/internationalization/flags/${flag}.svg`);
}
async function getFlagByCountry(country) {
  const res = await fetch(A.absoluteUrl(`/api/internationalization/countries/name/${country}?fields=flags`));
  const jsonRes = await res.json();
  return jsonRes[0].flags.svg;
}
function getAllCountries(lang = "en") {
  const countries = isoCountries.getCountries(lang);
  if (!countries)
    throw new Error(`invalid country: ${lang}`);
  return countries;
}
function getCountryByCode(langCode, lang) {
  if (!langCode)
    return "";
  return isoCountries.getCountry(lang, langCode);
}
async function getFlagByCode(langCode) {
  try {
    const res = await fetch(A.absoluteUrl(`/api/internationalization/countries/alpha/${langCode}?fields=flags`));
    const jsonRes = await res.json();
    return jsonRes.flags.svg;
  } catch (error) {
    return "";
  }
}
async function getAllFlags() {
  const countries = await getAllCountries("en");
  const res = await Promise.all(Object.entries(countries).map(([key, value]) => getFlagByCode(key)));
  return res;
}
async function getTranslatedLanguages(lang, selectedLanguages, toOriginal) {
  let langTranslationObj = {};
  if (toOriginal) {
    selectedLanguages.forEach((langOption) => {
      langTranslationObj[langOption] = isoCountries.getLanguage(langOption, langOption);
    });
  } else {
    selectedLanguages.forEach((langOption) => {
      langTranslationObj[langOption] = isoCountries.getLanguage(lang, langOption);
    });
  }
  return langTranslationObj;
}
export {
  flagAlias,
  getAllCountries,
  getAllFlags,
  getCountryByCode,
  getFlagByCode,
  getFlagByCountry,
  getFlagByLangAbbreviation,
  getTranslatedLanguages
};
